import { FC } from 'react'
import { useTranslate } from 'react-polyglot'
import { Button } from '@getgo/chameleon-web-react-wrapper'
import { Grid, makeStyles } from '@material-ui/core'
import { Dialog } from '@ucc/unified-admin-common'

import { useConnectedUserContext } from 'components/contexts/ConnectedUserContext'
import config from 'config'
import { PBX } from 'types/Pbx'

const E2E_TAGS = {
  DIALOG: 'unified-admin-shell-survey-dialog',
  PROVIDE_FEEDBACK_BTN: 'unified-admin-shell-survey-provide-feedback',
  DISMISS_BTN: 'unified-admin-shell-survey-dismiss',
}

const useStyles = makeStyles(() => ({
  buttonRow: {
    marginTop: 24,
  },
}))

export enum TriggerType {
  Exit = 'exit',
  SetupComplete = 'setup_complete',
  DynamicSetupComplete = 'dynamic_setup_complete',
  None = 'none',
}

interface GuidedSetupSurveyDialogProps {
  onClose: () => void
  pbx: PBX | null
  triggerType: TriggerType
}

const GuidedSetupSurveyDialog: FC<GuidedSetupSurveyDialogProps> = ({ onClose, pbx, triggerType }) => {
  const t = useTranslate()
  const classes = useStyles()
  const iam = useConnectedUserContext()

  const onGiveFeedbackClick = () => {
    const params = new URLSearchParams({
      account_id: iam?.key || '',
      pbx_id: pbx?.lmiAccountKey || '',
      pbx_creation: pbx?.creationDate || '',
      trigger: triggerType,
    })

    window.open(config.QUALTRICS_GUIDED_SETUP_SURVEY_URL + params.toString())
    onClose()
  }

  const getDialogTitle = () => {
    if (triggerType === TriggerType.SetupComplete || triggerType === TriggerType.DynamicSetupComplete) {
      return t('Congratulations! Your setup is complete')
    }
    if (triggerType === TriggerType.Exit) {
      return t('Help us improve our setup experience')
    }
  }

  return (
    <Dialog
      noMargin
      className={E2E_TAGS.DIALOG}
      title={getDialogTitle()}
      maxWidth="md"
      onClose={onClose}
      open={triggerType !== TriggerType.None}
    >
      <Grid container direction="column">
        <Grid item>{t('Are you willing to answer a few questions about your setup experience?')}</Grid>
        <Grid item className={classes.buttonRow}>
          <Grid direction="row" container spacing={2} justifyContent="center">
            <Grid item>
              <Button className={E2E_TAGS.PROVIDE_FEEDBACK_BTN} onClick={onGiveFeedbackClick}>
                {t('Provide feedback')}
              </Button>
            </Grid>

            <Grid item>
              <Button className={E2E_TAGS.DISMISS_BTN} variant="secondary" onClick={onClose}>
                {t('No thanks')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default GuidedSetupSurveyDialog
